/* eslint-disable react/prop-types */
import {
  Grid,
  darken,
  Box,
  Tooltip,
  IconButton,
  Link,
  Typography,
} from "@mui/material";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Download, FileDownload } from "@mui/icons-material";
import axios from "axios";
import { API_ROUTES } from "utils/constants";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import MDTypography from "components/MDTypography";

function BackupFile() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const axiosPrivateInstance = useAxiosPrivate();
  const [tableData, setTableData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isError, setIsError] = useState(false);
  const setAlert = useSetRecoilState(AlertState);
  useEffect(() => {
    // Lấy toàn bộ dữ liệu
    const loadBackup = async () => {
      if (!tableData.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
      await axiosPrivateInstance
        .get("listbackup")
        .then((res) => {
          setTableData(res.data?.backups);
        })
        .catch((error) => {
          console.log(error);
          setIsError(true);
          return;
        })
        .finally(() => {
          setIsError(false);
          setIsLoading(false);
          setIsRefetching(false);
        });
    };
    loadBackup();
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "file_name",
        header: "Tên file",
      },
      {
        accessorKey: "creation_date",
        header: "Thời gian tạo",
        size: 200,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value)?.isValid()
            ? dayjs(value)?.format("DD/MM/YYYY HH:mm")
            : value;
        },
      },
      {
        accessorFn: (row) => `${row.file_name}`,
        header: "Download file",
        size: 200,
        Cell: ({ row }) => (
          <MDTypography variant="h5" color="info">
            <Link
              href={`${API_ROUTES.DOWNLOADFILE}/${row.getValue("file_name")}`}
            >
              <FileDownload />
            </Link>
          </MDTypography>
        ),
      },
    ],
    []
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          manualPagination
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: 80,
            },
          }}
          initialState={{
            isLoading: true,
            pagination: { pageIndex: 0, pageSize: 20 },
            density: "compact",
          }}
          state={{
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BackupFile;
